import * as React from "react";
import { Provider } from "@fluentui/react-northstar/dist/es/components/Provider/Provider";
import { useEffect } from "react";
import { useTeams } from "msteams-react-base-component";
import * as microsoftTeams from "@microsoft/teams-js";

import FaqPage from "../../components/FaqPage/FaqPage";

import DataPrivacyLastUpdated from "../../components/DataPrivacyLastUpdated/DataPrivacyLastUpdated";
import { CpbxThemeSelector } from "../../components/CpbxThemeSelector/CpbxThemeSelector";
import Verhinderung from "../../components/Verhinderung/Verhinderung";

/**
 * Implementation of the TabDevTest content page (for SBK, FADE)
 */
export const TabFaq = () => {

    /*  ############################################################
        here is some stuff which you may use or not...
       - to get information if user is in teams-browser or normal browser (not within teams-app)
       - and other stuff (o365-login-info, theme to use, etc.)
    */
    const [{ inTeams, theme, context }] = useTeams();

    // magic initialization-stuff
    useEffect(() => {
        if (inTeams === true) {
            microsoftTeams.appInitialization.notifySuccess();
        }
        if (inTeams === false) {
            const outContext = { theme: "default" };
            CpbxThemeSelector(outContext);
        }
    }, [inTeams]);

    // check if we do have an o365-teams-context (meaning we are in teams-app and we are possibly logged in)
    useEffect(() => {
        microsoftTeams.registerOnThemeChangeHandler(function(theme) {
            CpbxThemeSelector(theme);
            console.log(theme);
        });
        if (context) {
            CpbxThemeSelector(context);
        }
    }, [context]);

    /*  ############################################################
        This is the stuff for html-output.
    */

    // output all in fully declartive way (not dynamically)
    return (
        <Provider theme={theme} className="cpbxProviderContainer">
            {/* <DataPrivacyLastUpdated />
            <FaqPage /> */}
            <Verhinderung/>
        </Provider>
    );

};
